import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from "@material-ui/core";
import { Storage } from "aws-amplify";
import awsconfig from "aws-exports";
import { useTranslation } from "react-i18next";
import { v4 as uuid } from "uuid";
import { Grid } from "@material-ui/core";
import ImageUploader from "components/atoms/ImageUploader";
import { cfOrigin } from "settings/storageSettings";

type Props = {
  onChange: any;
  value: any;
};
const UploadImage = (props: Props) => {
  const { value, onChange } = props;
  const [prevSrc, setPrevSrc] = useState(""); //選択候補フォト
  const { t } = useTranslation();

  const [open, setOpen] = React.useState(false);

  // 写真アップした際の挙動
  const _saveStorage = async (input: any) => {
    console.log("input:", input);
    const [, , , extension] = /([^.]+)(\.(\w+))?$/.exec(input.name);
    let storage: any = await Storage.put(
      `${uuid()}${extension && "."}${extension}`,
      input,
      { contentType: input.type }
    );
    console.log("successfully saved file...");

    const s3object = {
      bucket: awsconfig.aws_user_files_s3_bucket,
      region: awsconfig.aws_user_files_s3_bucket_region,
      key: storage.key,
    };

    const parser = new URL(
      await Storage.get(s3object.key, {
        level: "public",
        download: false,
      })
    );

    let myPrevsrc = "";
    if (cfOrigin) {
      myPrevsrc = `${cfOrigin}${parser.pathname}`;
    } else {
      myPrevsrc = `${parser.origin}${parser.pathname}`;
    }

    onChange([s3object, myPrevsrc]);
    setPrevSrc(myPrevsrc);
    setOpen(false);
  };

  const onDrop = (picture: any[]) => {
    _saveStorage(picture[0]);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };

  React.useEffect(() => {
    if (value && typeof value === "object" && "key" in value) {
      async function f() {
        const url = await Storage.get(value.key, {
          level: "public",
          download: false,
        });
        const parser = new URL(url);
        let myPrevsrc = "";
        if (cfOrigin) {
          myPrevsrc = `${cfOrigin}${parser.pathname}`;
        } else {
          myPrevsrc = `${parser.origin}${parser.pathname}`;
        }

        setPrevSrc(myPrevsrc);
        onChange([value, myPrevsrc]);
      }
      f();
    }
  }, [value]);
  React.useEffect(() => {}, [prevSrc]);

  return (
    <>
      {prevSrc && (
        <>
          <Grid>
            <img style={{ width: "100%", maxWidth: 800 }} src={prevSrc}></img>
          </Grid>
        </>
      )}
      <Button
        variant="contained"
        color="primary"
        component="div"
        onClick={handleClickOpen}
      >
        {t("Add Photo")}
      </Button>

      <Dialog
        fullWidth
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogContent>
          <ImageUploader onDrop={onDrop} />
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {t("Cancel")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default UploadImage;
